module.exports = __webpack_public_path__ + "static/media/appstoreicon.248a52c5.svg";